import { createReducer, on } from '@ngrx/store';
import { ReportViewSearchActions } from './search.actions';
import {
  ReportViewSearchState,
  initialReportViewSearchState,
  reportViewSearchState
} from './search.state';

export const reportViewSearchReducer = createReducer(
  reportViewSearchState,
  on(
    ReportViewSearchActions.reset,
    (): ReportViewSearchState => initialReportViewSearchState
  ),
  on(
    ReportViewSearchActions.updateKeyword,
    (state, { keyword }): ReportViewSearchState => ({
      ...state,
      keyword
    })
  ),
  on(
    ReportViewSearchActions.updateLoading,
    (state, { loading }): ReportViewSearchState => ({
      ...state,
      loading
    })
  ),
  on(
    ReportViewSearchActions.updateCategory,
    (state, category): ReportViewSearchState => ({
      ...state,
      category
    })
  ),
  on(
    ReportViewSearchActions.updateTrait,
    (state, trait): ReportViewSearchState => ({
      ...state,
      trait
    })
  )
);
